import { useState, useEffect } from "react";
import { API_BASE_URL } from "../services/common/constants";

interface FeatureFlags {
  digitalLocks: boolean;
}

const defaults: FeatureFlags = {
  digitalLocks: false,
};

let cachedFlags: FeatureFlags | null = null;
let fetchPromise: Promise<FeatureFlags> | null = null;

function fetchFeatureFlags(): Promise<FeatureFlags> {
  if (cachedFlags) return Promise.resolve(cachedFlags);
  if (fetchPromise) return fetchPromise;

  fetchPromise = fetch(`${API_BASE_URL}/api/config/features`)
    .then((res) => {
      if (!res.ok) return defaults;
      return res.json() as Promise<FeatureFlags>;
    })
    .then((data) => {
      cachedFlags = data;
      return data;
    })
    .catch(() => defaults);

  return fetchPromise;
}

export function useFeatureFlags(): FeatureFlags {
  const [flags, setFlags] = useState<FeatureFlags>(cachedFlags ?? defaults);

  useEffect(() => {
    fetchFeatureFlags().then(setFlags);
  }, []);

  return flags;
}
